import PropTypes from "prop-types"
import { get } from "lodash"
import { Table, TableHead, TableRow, TableCell } from "@mui/material"
import { sortData } from "helpers/contributorsSort"
import { numberFormatter } from "helpers/formatters/numbers"
import { useTrack } from "helpers/analytics"
import ContributorsOptions from "components/contributors-options"
import ContributorsSorting from "components/contributors-sorting"
import ContributorsTableContent from "components/contributors-table-content"
import ContributorsTableHead from "components/contributors-table-head"
import { VIEW_TYPES } from "helpers/base"
import "./style.scss"

function CompositeFactorSensitivityContributors({
  viewType,
  selectedContributorCategory,
  selectedContributorValue,
  showContributorCategory,
  hideContributorCategory,
  contributors,
  openSecurityProfile,
  openFactorProfile,
  openCompositeSecurity,
  selectedGroup,
  selectedGroupValue,
  selectedGroupSiblings,
  showGroup,
  hideGroup,
  currentGrouping,
  setGrouping,
  groupedData,
  sortOrder,
  sort,
  groupOrder,
  availableRollups,
  contributorsSummaryText,
  excelData,
  selectedOption,
  groupBy,
  details,
  groupsDropdownColumns,
  page,
  setPage,
}) {
  const trackExcelDownload = useTrack({
    type: "composite-analyze-factor-sensitivity-contributors-download",
  })

  const onBackClick = selectedGroup ? hideGroup : hideContributorCategory
  const selectedOptionColor = get(selectedOption, "color")

  return <div className="contributors-details-wrapper">
    <ContributorsOptions
      {...{
        contributorsSummaryText,
        availableRollups,
        setGrouping,
        currentGrouping,
        selectedGroup,
        csvData: excelData,
        toggleShowNotHeld: null,
        groupBy,
        trackExcelDownload,
      }}
    />

    <Table className="contributors-details-table">
      <TableHead>
        <TableRow className="sorting-row">
          <ContributorsSorting label="Name" id="name" order={sortOrder} sort={sort} />
          <ContributorsSorting align="right" label={viewType === VIEW_TYPES.ABSOLUTE ? "% Equity" : "Active % Equity"} id="equity" order={sortOrder} sort={sort} />
          <ContributorsSorting align="right" label="1 STD Factor Impact (%)" id="viewType" order={sortOrder} sort={sort} />
        </TableRow>
        <TableRow>
          <ContributorsTableHead
            label={selectedGroup ? selectedGroup.name : selectedContributorCategory.label}
            color={selectedOptionColor}
            onBackClick={onBackClick}
            dropdownColumns={groupsDropdownColumns}
            dropdownItems={selectedGroup ? selectedGroupSiblings : sortData(details, groupOrder)}
            onDropdownItemClick={(item) => selectedGroup ? showGroup(item) : showContributorCategory(item)}
            selectedItemId={selectedGroup ? selectedGroup.id : selectedContributorCategory.id}
          />
          <TableCell align="right" style={{ color: selectedOptionColor }}>{selectedGroup ? numberFormatter(selectedGroup.totalPercentEquity * 100) : "-"}</TableCell>
          <TableCell align="right" style={{ color: selectedOptionColor }}>{numberFormatter(selectedGroup ? selectedGroupValue : selectedContributorValue) || "-"}</TableCell>
        </TableRow>
      </TableHead>
      <ContributorsTableContent
        selected={selectedContributorCategory}
        openSecurityProfile={openSecurityProfile}
        openFactorProfile={openFactorProfile}
        openCompositeSecurity={openCompositeSecurity}
        data={contributors}
        noPercent
        contributorsGrouping={currentGrouping}
        selectedGroup={selectedGroup}
        showGroup={showGroup}
        groupedData={groupedData}
        page={page}
        setPage={setPage}
      />
    </Table>
  </div>
}

CompositeFactorSensitivityContributors.propTypes = {
  modelId: PropTypes.string.isRequired,
  positionSetId: PropTypes.string.isRequired,
  positionSetType: PropTypes.string.isRequired,
  positionSetName: PropTypes.string.isRequired,
  segment: PropTypes.object,
  classifications: PropTypes.array,
  selectedDate: PropTypes.string,
  selectedContributorCategory: PropTypes.object.isRequired,
  selectedContributorValue: PropTypes.number.isRequired,
  selectedViewsFactors: PropTypes.array,
  contributors: PropTypes.array.isRequired,
  viewType: PropTypes.string.isRequired,
  expand: PropTypes.bool,
  aggregation: PropTypes.string,
  mustAggregateFactors: PropTypes.bool,
  sortOrder: PropTypes.object.isRequired,
  sort: PropTypes.func.isRequired,
  showContributorCategory: PropTypes.func.isRequired,
  hideContributorCategory: PropTypes.func.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  openCompositeSecurity: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  selectedGroupValue: PropTypes.number,
  selectedGroupSiblings: PropTypes.array,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  currentGrouping: PropTypes.object,
  setGrouping: PropTypes.func.isRequired,
  groupedData: PropTypes.array.isRequired,
  availableRollups: PropTypes.array.isRequired,
  contributorsSummaryText: PropTypes.string.isRequired,
  excelData: PropTypes.object.isRequired,
  selectedOption: PropTypes.object.isRequired,
  groupBy: PropTypes.string,
  details: PropTypes.array.isRequired,
  groupOrder: PropTypes.object.isRequired,
  groupsDropdownColumns: PropTypes.array,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  factorSensitivityType: PropTypes.string.isRequired,
  showNotHeld: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
}

export default CompositeFactorSensitivityContributors
